import { AxiosResponse } from 'axios';
import { SimpleContact } from 'institution-service-shared';

import axios from '../axios';
import { TRIALS_API_ROOT } from '../constants';

export const contactApi = {
  getMultipleContacts: async (ids: string[]): Promise<AxiosResponse<SimpleContact[]>> => {
    return axios.post(`${TRIALS_API_ROOT}/institutions/contacts`, { ids });
  },
};
